import {User} from '../../model/user';

export interface UsersState {
  users: User[];
}

export const initialUsersState: UsersState = {
  users: null,
};
